import { IconButton } from "@components/button";
import { IFocusableItemProps } from "@components/focusManager";
import { StatusYesIcon } from "@components/icon";
import {
    CaretIconRight,
    CaretWrapper,
    Circle,
    IconWrapper,
    TaskRowStyled,
    TaskRowWrapper
} from "@pages/fiscalYearClose/FiscalYearClose.styles";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { IconSize } from "../../enums";
import { KeyName } from "../../keyName";
import TestIds from "../../testIds";

interface IProps {
    taskId: string;
    title: string;
    onTaskSelect: (id: string) => void;
    isChecked: boolean;
    isSelected: boolean;
    isClosed: boolean;
    isDisabled: boolean;
    itemProps: IFocusableItemProps;
}

export const SplitPageWizardRow: React.FC<IProps> = ({
                                                         taskId,
                                                         onTaskSelect,
                                                         isChecked,
                                                         isSelected,
                                                         isClosed,
                                                         isDisabled,
                                                         itemProps,
                                                         title
                                                     }) => {
    const { t } = useTranslation("Common");
    const handleClick = useCallback((): void => {
        if (isDisabled) {
            return;
        }
        onTaskSelect(taskId);
    }, [taskId, isDisabled, onTaskSelect]);

    const handleKeyDown = useCallback((event: React.KeyboardEvent): void => {
        if (isDisabled) {
            return;
        }
        if (event.key === KeyName.Enter) {
            onTaskSelect(taskId);
        }
    }, [taskId, isDisabled, onTaskSelect]);

    function getCaretIcon(): React.ReactElement {
        return <CaretWrapper onClick={handleClick} data-testid={TestIds.TaskRowCaret}>
            <IconButton
                    tabIndex={-1}
                    isDecorative
                    title={t("Common:General.Open")}>
                <CaretIconRight height={IconSize.M} width={IconSize.M}/>
            </IconButton>
        </CaretWrapper>;
    }

    // return () {
    // if (task === FiscalYearCloseSectionTypeCode.FinalClosure) {
    //     return <TaskRowWrapper isSelected={isSelected} data-testid={TestIds.TaskRow}>
    //         <TaskRowStyled
    //                 {...itemProps}
    //                 onClick={this.handleClick}
    //                 onKeyDown={this.handleKeyDown}
    //                 isSelected={isSelected}
    //                 isClosing={true}
    //                 isChecked={isClosed}
    //                 data-testid={TestIds.TaskRowContent}>
    //             <IconWrapper data-testid={TestIds.TaskRowStatusIcon}>
    //                 {isClosed ? <StatusYesIcon width={IconSize.M} height={IconSize.M}/> : <Circle/>}
    //             </IconWrapper>
    //             {isClosed ? <>
    //                 {storage.t("FiscalYearClose:ClosedLabel")}&nbsp;
    //                 <i>{storage.t("FiscalYearClose:ClosedLabelBrackets", { date: DateType.format(storage.getValueByPath("DateClosed")) })}</i>
    //             </> : storage.t(`FiscalYearClose:Task.${task}${isCbaCompany ? "Cba" : ""}`)}
    //         </TaskRowStyled>
    //         {this.caretIcon}
    //     </TaskRowWrapper>;
    // }
    //
    return (<TaskRowWrapper isSelected={isSelected} data-testid={TestIds.TaskRow} isDisabled={isDisabled}>
        <IconWrapper data-testid={TestIds.TaskRowStatusIcon}>
            {isChecked ? <StatusYesIcon width={IconSize.M} height={IconSize.M}/> : <Circle/>}
        </IconWrapper>
        <TaskRowStyled
                {...itemProps}
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                isSelected={isSelected}
                isChecked={isChecked}
                data-testid={TestIds.TaskRowContent}>
            {title}
        </TaskRowStyled>
        {getCaretIcon()}
    </TaskRowWrapper>);
};
